<template>
  <div class="d-flex" :id="'chart_'+uuid">
    <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
      <canvas :id="uuid" :width="size.width" :height="size.height" />
    </div>
    <div :id="uuid+'_legend'" style="max-width: 400px">
      <p class="my-reason" v-for="(reason, index) in element" :key="reason">
        <v-avatar :color="palette[index]" size="20">
          <span style="font-size: 10px; z-index: 2; font-weight: bold;" :style="`color: ${Colorize(palette[index])}`">{{ index + 1 }}</span>
        </v-avatar>
        <span :class="reason.element === 'Причина аварийности не указана' ? 'accent' : null" style="margin-left: -3px; padding-left: 10px; z-index: 1" :style="`border-bottom: 1px solid ${palette[index]};`">{{ reason.element }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import {Chart} from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {Colorize, palette} from "@/libs/colorizer";

export default {
  name: "43929d70-0d26-11eb-8114-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      element: [],
      count: [],
      reasons: []
    }
  },
  computed: {
    palette() {
      return palette
    },
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    make_chart: function () {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels],
          data: {
            labels: this.reasons,
            datasets: [
              {
                label: this.chart.report_description,
                data: this.count,
                maxBarThickness: 800
              }
            ]
          },
          options: {
            layout: {
              padding: {
                top: 25
              }
            },
            plugins: {
              autocolors: {
                mode: 'data'
              },
              legend: {
                display: false
              },
              datalabels: {
                anchor: 'end',
                clamp: true,
                align: 'end'
              }
            },
            scales: {
              x: {
                stacked: true,
                ticks: {
                  // Include a dollar sign in the ticks
                  callback: function(index) {
                    return index+1;
                  }
                }
              },
              y: {
                title: {
                  display: true,
                  text: 'Кол-во аварийных обращений'
                },
                beginAtZero: true
              }
            }
          }
        });
      }
    },
    update_data: function () {
      this.element = []
      this.count = []
      this.reasons = []
      for (let i =0; i < this.chart.report_data.length; i++) {
        if (!this.reasons.includes(this.trim(this.chart.report_data[i]["ПричинаИнцидентаПРЕДСТАВЛЕНИЕ"]))) {
          this.reasons.push(this.trim(this.chart.report_data[i]["ПричинаИнцидентаПРЕДСТАВЛЕНИЕ"]))
          this.count.push(0)
        }
      }
      for (let i = 0; i < this.chart.report_data.length; i++) {
        this.count[this.reasons.indexOf(this.trim(this.chart.report_data[i]["ПричинаИнцидентаПРЕДСТАВЛЕНИЕ"]))] += this.chart.report_data[i]["Обращение"]
      }
      for (let i = 0; i < this.reasons.length; i++) {
        this.element.push({
          element: this.reasons[i] ? this.reasons[i] : 'Причина аварийности не указана',
          count: this.count[i]
        })
      }
      this.element = this.element.sort(function (a, b) {
        return parseFloat(b.count) - parseFloat(a.count)
      })
      for (let i = 0; i < this.element.length; i++) {
        this.reasons[i] = this.element[i].element
        this.count[i] = this.element[i].count
      }
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    },
    Colorize,
    trim: function (string) {
      if (string) {
        string = string.replace(/[^a-zA-Zа-яА-Я]/g, " ")
        return string.trimStart()
      } else {
        return null
      }

    }
  }
}
</script>


<style scoped>
.my-reason {
  font-size: 14px;
  color: #6f6f6f;
}
.accent {
  font-weight: bolder;
}
</style>